/*eslint-disable*/
require('./polyfill');
require('./services/bugsnag');

import Vue from 'vue';

import style from '../assets/sass/style.scss';

import Focus from '@/directives/focus.directive'
import FocusOnFirst from '@/directives/focusOnFirst.directive'
Vue.directive('focus', Focus);
Vue.directive('focus-on-first', FocusOnFirst);

import apiFileFilter from '@/filters/api.filter'
Vue.filter('apiFile', apiFileFilter);

window.io = require('socket.io-client');
import VueEcho from 'vue-echo';
if (!env.offline) {
    Vue.use(VueEcho, {
        broadcaster: 'socket.io',
        host: api.env.SOCKET_URL + ':' + api.env.SOCKET_PORT,
    });
}

window.createjs = window.createjs || {};
require('@danzen/createjs');
Vue.prototype.$createjs = window.createjs;

const makeZIM = require('zimjs-akdev');
const zim = makeZIM();
window.zim = zim;

const croppie = require('croppie');
const moment = require('moment');
require('moment/locale/ru');
moment.updateLocale('ru', {
    calendar: {
        lastDay: '[Вчера]',
        sameDay: '[Сегодня]',
        nextDay: '[Завтра]',
        lastWeek: 'DD.MM.YYYY',
        nextWeek: 'DD.MM.YYYY',
        sameElse: 'DD.MM.YYYY',
    },
    months: function(momentToFormat, format) {
        if (/^D/.test(format)) {
            return [
                'Января',
                'Февраля',
                'Марта',
                'Апреля',
                'Мая',
                'Июня',
                'Июля',
                'Августа',
                'Сентября',
                'Октября',
                'Ноября',
                'Декабря',
            ][momentToFormat.month()];
        } else {
            return [
                'Январь',
                'Февраль',
                'Март',
                'Апрель',
                'Май',
                'Июнь',
                'Июль',
                'Август',
                'Сентябрь',
                'Октябрь',
                'Ноябрь',
                'Декабрь',
            ][momentToFormat.month()];
        }
    },
});
Vue.use(require('vue-moment'), { moment });

import InfiniteScroll from 'v-infinite-scroll';
Vue.use(InfiniteScroll);

import VueViewports from 'vue-viewports';
Vue.use(VueViewports, {
    300: 'mobile',
    769: 'tablet',
    1000: 'desktop',
    1192: 'widescreen',
    1384: 'ullhd'
});

import Toasted from 'vue-toasted';
Vue.use(Toasted, {
    duration: 2000,
});

import PortalVue from 'portal-vue';
Vue.use(PortalVue);

import Vuex from 'vuex';
Vue.use(Vuex);

import canPlugin from '@/plugins/can.plugin'
import envPlugin from '@/plugins/env.plugin'
import VueAutosize from 'vue-autosize';

Vue.use(canPlugin)
Vue.use(envPlugin)
Vue.use(VueAutosize);

require('./services/validator');

import Multiselect from 'vue-multiselect';
Vue.component('Multiselect', Multiselect);

require('./defaultComponents.build');


window.$ = window.jQuery = require('jquery');
require('fullcalendar');

export default Vue;
